import socketIOClient from 'socket.io-client';
import EventHandler from './EventHandler';
// import translations from 'helpers/localization';
// import { logSentryError } from 'components/integrations/events/eventDispatcherApi';
import _partial from 'lodash/partial';
import { _get, _isFunction, _map } from '../../../utils/helpers/zupeeLodash';
import { getGameplaySpEventData } from '../../../utils/helpers/common';

const RECONNECTION_DELAY = 1000;
const RECONNECTION_DELAY_MAX = 5000;
const RETRY_TIMEOUT = 2000;

const SOCKET_ERROR_CODES = {
	CONNECTION_TIMEOUT: 'CONNECTION_TIMEOUT',
	CONNECTION_ERROR: 'CONNECTION_ERROR',
	DISCONNECTION: 'DISCONNECTION',
	VISIBILITY: 'VISIBILITY'
};

class Socket {
	constructor() {
		this.socket = null;
		this.event_handlers = [];
		this.isReconnecting = false;
		this.shouldReconnect = false;
		this.socketDestroyed = false;
	}

	isSocketConnected = () => _get(this.socket, 'connected');

	connectToSocket = () => {
		if (this.socket) {
			this.socket.connect();
		}
	};

	reconnectSocket = (errorCode) => {
		if (!this.isReconnecting && !this.isSocketConnected()) {
			this.isReconnecting = true;
			this.connectToSocket();
		}
	};

	onError = (errorCode) => {
		console.log("Socket error:", errorCode);
		if (!this.isSocketConnected()) {
			this.isReconnecting = false;
			this.reconnectSocket(errorCode);
		}
	};

	connect_socket = async ({ params, onSocketConnected }) => {
		if (this.isConnecting || this.isSocketConnected()) {
			return;
		}

		this.isConnecting = true;
		this.socketDestroyed = false;

		let { proto, host, port, ...rest } = params || {};
		this.spQuery = await getGameplaySpEventData({SOCKETTYPE:"MAIN_CLIENT", ...rest});

		// if (RESTRICTED_PORTS.has(port)) {
		// 	port = allPorts[Math.floor(Math.random() * allPorts.length)];
		// }
		this.socket =  socketIOClient(`${proto}://${host}:${port}`, {
			reconnection: false,
			timeout: 20000,
			transports: ['websocket'],
			reconnectionDelay: RECONNECTION_DELAY,
			reconnectionDelayMax: RECONNECTION_DELAY_MAX,
			reconnectionAttempts: Infinity,
			query: this.spQuery
		});
		const socket = this.socket;
		
		const handleError = (type) => {
			console.log(`Socket error type: ${type}`);
			this.onError(type);
		};

		socket.on('error', () => handleError(SOCKET_ERROR_CODES.CONNECTION_ERROR));
		socket.on('connect_error', () => handleError(SOCKET_ERROR_CODES.CONNECTION_ERROR));
		
		socket.on('connect', () => {
			this.isReconnecting = false;
		});
		socket.on('res', this.handle_events);
		// call calback of on authentciated
		if (_isFunction(onSocketConnected)) {
			onSocketConnected();
			return;
		}
		if (this.shouldReconnect) {
			// on visibility change check if the socket is connected else make a new connection
			// onDisconnect make fresh connection
			// we do not do this in gameplay because we do reload there
			document.addEventListener('visibilitychange', () => {
				if (document.visibilityState === 'visible') {
					this.reconnectSocket(SOCKET_ERROR_CODES.VISIBILITY);
				}
			});
			socket.on('disconnect', () => {
				// show loader
				if (this.socketDestroyed) {
					return;
				}
				// store.dispatch(show_loader(translations.reconnecting));
				this.reconnectSocket(SOCKET_ERROR_CODES.DISCONNECTION);
			});
		}
	}

	destroy_socket = () => {
		if (this.socket && this.socket.connected) {
			this.socketDestroyed = true;
			this.socket.disconnect();
			this.socket = null;
			this.event_handlers = [];
		}
	};

	handle_events = (res) => {
		const timestamp = new Date().getTime();
		console.log("res in socket", res, "timestamp", timestamp);
		_map(this.event_handlers, (handler) => {
			if (handler instanceof EventHandler) {
				handler.handleSocketData(res);
			}
		});
	};

	add_event_handler = (event_handler) => {
		this.event_handlers.push(event_handler);
	};

	emit = (data) => {
		if (this.socket && this.socket.connected) {
			this.socket.emit('req', data);
		}
	};
}
export default Socket;
